
import { DataGroup } from "../../../models/dataGroup.model.ts";
import { DataGroupTeamSerializer } from "../../../models/serializers/dataGroupTeamSerializer.ts";
import { httpRequest } from "../../http";

export class CommandLookUpList {
    async run() {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/title-lookup/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
             return this.deserialize(response.titles.items);
                    
                
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : DataGroup []{
        const serializer = new DataGroupTeamSerializer();
        return serializer.deserializeList(data);
    }
    
}

